import { makeJsonApiRequest } from '@base/axios.ts'
import { createLogger } from '@utils/logger.ts'

const log = createLogger('CustomizationWebAPI')
log.setLevel('info')

export default {
  saveCustomization: function (customizableType, customizableId, formData) {
    log.debug('saveCustomization called with:', { customizableType, customizableId, formData })

    const url = `/api/v2/customizations`
    const data = {
      data: {
        type: 'customizations',
        attributes: {
          customizable_type: customizableType,
          customizable_id: customizableId,
          values: formData,
        },
      },
    }
    return makeJsonApiRequest({
      url,
      method: 'post',
      data,
      requestId: `save-customization-${customizableType}-${customizableId}`,
    })
  },
}
